var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6578 1.34223C12.2087 1.89305 12.4892 2.61065 12.4997 3.33319V3.37513C12.4997 4.11177 12.219 4.84655 11.6575 5.40802L10.919 6.1466L6.60193 10.4636C6.54535 10.5202 6.45391 10.5202 6.39733 10.4636C6.39732 10.4636 6.39732 10.4636 6.39732 10.4636L2.08059 6.14661L2.08058 6.1466L1.342 5.40802C0.219332 4.28535 0.219332 2.4649 1.342 1.34223L1.34209 1.34215C1.90347 0.780507 2.63787 0.500076 3.3749 0.500076C4.11193 0.500076 4.84633 0.780507 5.40771 1.34215L5.40779 1.34223L6.14637 2.08081L6.49992 2.43436L6.85348 2.08081L7.59205 1.34223L7.59209 1.34219C8.71476 0.21927 10.5351 0.21927 11.6578 1.34219L11.6578 1.34223Z",
    stroke: "#4F617B",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c0f9f61e2ae0af34d6bc02ce7e6d0c39.svg";
export { ForwardRef as ReactComponent };